import { render } from "./GardenTimeSoltsManagement.vue?vue&type=template&id=cb4bbf52&scoped=true"
import script from "./GardenTimeSoltsManagement.vue?vue&type=script&lang=js"
export * from "./GardenTimeSoltsManagement.vue?vue&type=script&lang=js"

import "./GardenTimeSoltsManagement.vue?vue&type=style&index=0&id=cb4bbf52&lang=scss&scoped=true"

import exportComponent from "/home/forge/app-ticket.grandigiardini.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4bbf52"]])

export default __exports__